var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.729 1.27107C11.34 0.880067 10.708 0.878067 10.315 1.26707C10.211 1.37107 10.139 1.49407 10.09 1.62207C9.258 3.35807 8.342 4.33707 7.186 4.91507C5.889 5.55507 4.4 6.00007 2 6.00007C1.87 6.00007 1.74 6.02507 1.618 6.07607C1.373 6.17807 1.179 6.37307 1.077 6.61707C0.976 6.86107 0.976 7.13707 1.077 7.38107C1.128 7.50407 1.201 7.61507 1.294 7.70707L4.537 10.9501L0 17.0001L6.05 12.4631L9.292 15.7051C9.384 15.7991 9.495 15.8711 9.618 15.9221C9.74 15.9731 9.87 16.0001 10 16.0001C10.13 16.0001 10.26 15.9731 10.382 15.9221C10.627 15.8201 10.822 15.6271 10.923 15.3811C10.974 15.2601 11 15.1291 11 15.0001C11 12.6001 11.444 11.1111 12.083 9.83407C12.66 8.67807 13.639 7.76207 15.376 6.93007C15.505 6.88107 15.627 6.80907 15.73 6.70507C16.119 6.31207 16.117 5.68007 15.726 5.29107L11.729 1.27107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/PinIcon.f85ceab723d3f6de77449d3971ec1800.svg";
export { ForwardRef as ReactComponent };